var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["page-content account", { "not-acc-sf": !_vm.accountSummaryFlow }]
    },
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "limits" }, [
            !_vm.accountSummaryFlow
              ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.PlayLimits")))])
              : _vm._e(),
            _vm._v(" "),
            !_vm.timeLimits
              ? _c(
                  "div",
                  { staticClass: "loader" },
                  [
                    _c("v-progress-circular", {
                      staticClass: "circular-progress",
                      attrs: { indeterminate: "" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.timeLimits
              ? _c(
                  "div",
                  { staticClass: "limits-container" },
                  _vm._l(_vm.timeLimits, function(limit, index) {
                    return _c(
                      "div",
                      { key: index },
                      [_c("TimeLimit", { attrs: { limit: limit } })],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c92639b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c92639b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Limits/V3RI/TimeLimits.vue
// module id = null
// module chunks = 